import { Router } from 'pjax';
import index from './index';

Router.get('contract', index);
